module.exports = __webpack_public_path__ + "img/edge_sharp.c0852041.webp";